import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;
const staticServerBaseURL = process.env.REACT_APP_STATIC_SERVER_URL;

export const getTrainers = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/trainers`, { params });
};

export const getTrainer = async (params) => {
  return await axios.get(`${baseURL}/trainer/`, { params });
};

export const addTrainer = async (values) => {
  return await axios.post(`${baseURL}/trainer`, values);
};

export const updateTrainerInfo = async (id, values) => {
  return await axios.put(`${baseURL}/trainer/${id}`, values);
};

export const getTrainerPublicProfileInfo = async (params) => {
  return await axios.get(`${baseURL}/trainer-public-profile/`, { params });
};

export const getTrainerPublicProfilesInOrder = async (params) => {
  return await axios.get(`${baseURL}/trainer-ordering`, { params });
};

export const updateTrainerPublicProfileOrder = async (value) => {
  return await axios.put(`${baseURL}/trainer-ordering`, value);
};

export const updateTrainerPublicProfileInfo = async (id, values) => {
  return await axios.put(`${baseURL}/trainer-public-profile/${id}`, values);
};

export const uploadTrainerImage = async (payload, location) => {
  return await axios.post(`${baseURL}/trainer/uploadings/${location}`, payload);
};
